import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dasher',
})
export class DasherPipe implements PipeTransform {
  transform(value: any) {
    if (value === 0 || value === false || (value && value.toString)) {
      return value.toString();
    }
    return '--';
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/pipes/secure/dasher.pipe.ts